import React from 'react';
import { Flex } from '@components';
import { Button, Select, Spin, Form, message, Input } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import NextButton from '@pages/SelfHelp/common/nextIndex';
import './index.css';
import NHFormItem from "@components/common/NHFormItem";
import NHFetch from '@utils/NHFetch';
import NHSelect from "@components/common/NHSelect";
import { getLoginUser } from '@utils/NHCore';
import { mkbz as mkbzRouteMap } from '@pages/Assembly/siderMenu/menuObj';
import Hint from '@pages/SelfHelp/common/hint';

const { Option } = Select;

function buildMenuStepUrl(menu) {
    if (!menu) {
        return { url: '', search: '' };
    }
    const hjdm = menu.HJDM;
    if (hjdm.indexOf('GD') === 0) {
        return { url: mkbzRouteMap[hjdm] || '', search: `pkid=${menu.PKID}` };
    }
    if (hjdm.indexOf('ZDY') === 0) {
        return { url: '/customLink', search: `pkid=${menu.PKID}&mkbz=${hjdm}&lx=${menu.LX}` };
    }
    if (hjdm.indexOf('DCWJ') === 0) {
        return { url: '/customizeExamination', search: `pkid=${menu.PKID}&mkbz=${hjdm}` };
    }
    return { url: '', search: '' };
}

@Form.create()
export default class ChooseDormitoryTjstsx extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD006_11',
            hjmc: '',
            loading: false,
            nextUrl: '',
            search: '',
            linkHandled: false,
            selectedOrientation: '',
            selectedBedNo: '',
            sceneImgLoadError: false,
            diagramImgLoadError: false,
            sssyt_csbz: 'TJSTSXY_YX_ZZBD_ZXSS_SSSYT',
            sssjt_csbz: 'TJSTSXY_YX_ZZBD_ZXSS_SSSJT',
            /** 朝向 code -> 可选床位号列表，来自 /tjstsxy/queryCwhOptionsByStu，如 { "07": ["9","8",...] } */
            orientationBedMap: {},
            /** 床位接口是否已返回（用于避免在数据未到时就把朝向全部过滤掉） */
            cwhOptionsLoaded: false,
        };
    }

    // UNSAFE_componentWillMount = () => {
    //     this.checkIsZzbdHjLinked();
    // }

    componentDidMount() {
        const { sssyt_csbz, sssjt_csbz } = this.state;
        this.getSssyt(sssyt_csbz);
        this.getSssjt(sssjt_csbz);
        this.queryQztjAndYlhj();
        this.checkIsZzbdHjLinked();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.selectedOrientation !== this.state.selectedOrientation ||
            prevState.selectedBedNo !== this.state.selectedBedNo
        ) {
            this.syncDormitoryFormFields();
        }
    }

    /** NHFormItem + getFieldDecorator 会接管子组件 value，仅改 state 不会更新表单域，Select 无法匹配 Option 则无 label */
    syncDormitoryFormFields = () => {
        const { form } = this.props;
        if (!form || !form.setFieldsValue) {
            return;
        }
        const { selectedOrientation, selectedBedNo } = this.state;
        form.setFieldsValue({
            fjcx: selectedOrientation !== '' && selectedOrientation != null ? selectedOrientation : undefined,
            cwh: selectedBedNo !== '' && selectedBedNo != null ? selectedBedNo : undefined,
        });
    };

    // 查询学生可选床位号：data 为 { 朝向code: 床位号数组 }，如 { "07": ["9","8","7"] }
    queryCwhOptionsByStu = () => {
        NHFetch('/tjstsxy/queryCwhOptionsByStu', 'GET')
            .then(res => {
                const map =
                    res && res.code === 200 && res.data && typeof res.data === 'object' && !Array.isArray(res.data)
                        ? res.data
                        : {};
                if (!(res && res.code === 200 && res.data && typeof res.data === 'object' && !Array.isArray(res.data))) {
                    if (res && res.code !== 200 && res.message) {
                        message.error(res.message);
                    }
                }
                this.setState(prev => {
                    const validKeys = Object.keys(map).filter(
                        k => Array.isArray(map[k]) && map[k].length > 0
                    );
                    const curOrientation = prev.selectedOrientation != null ? String(prev.selectedOrientation) : '';
                    const curBedNo = prev.selectedBedNo != null ? String(prev.selectedBedNo) : '';

                    const next = {
                        orientationBedMap: map,
                        cwhOptionsLoaded: true,
                    };
                    // 环节未办理时：若选择与当前可选床位映射不一致则清空；已办理时保留回填，不因过滤映射清空
                    if (!prev.linkHandled) {
                        if (curOrientation && validKeys.indexOf(curOrientation) === -1) {
                            next.selectedOrientation = '';
                            next.selectedBedNo = '';
                            return next;
                        }
                        if (curOrientation && curBedNo) {
                            const bedOptions = Array.isArray(map[curOrientation]) ? map[curOrientation] : [];
                            const bedSet = new Set(bedOptions.map(b => String(b)));
                            if (!bedSet.has(curBedNo)) {
                                next.selectedBedNo = '';
                            }
                        }
                    }
                    return next;
                });
            })
            .catch(() => {
                this.setState({
                    orientationBedMap: {},
                    cwhOptionsLoaded: true,
                    selectedOrientation: '',
                    selectedBedNo: '',
                });
                message.error('获取床位号失败');
            });
    };

    // 查询已办理的床位选择：SSCX=朝向，CWH=床位号
    queryChooseDormitory = () => {
        NHFetch('/tjstsxy/queryChooseDormitory', 'GET',)
            .then(res => {
                const sscx = res && res.data ? res.data.SSCX : '';
                const cwh = res && res.data ? res.data.CWH : '';
                // 已办理环节仅回填展示，朝向不做床位映射校验清空（与未办理时的下拉过滤解耦）
                this.setState({ selectedOrientation: sscx, selectedBedNo: cwh });
            })
            .catch(() => {
                // 不影响页面可用性，只是不回填
            });
    };

    // 朝向下拉：仅环节未办理时，才按可选床位过滤；已办理时展示字典全量，保证回填与标签一致
    getOrientationFilterData = () => {
        const { orientationBedMap, cwhOptionsLoaded, linkHandled, selectedOrientation } = this.state;
        if (linkHandled) {
            return undefined;
        }
        if (!cwhOptionsLoaded) {
            return undefined;
        }
        const keys = Object.keys(orientationBedMap || {}).filter(
            k => Array.isArray(orientationBedMap[k]) && orientationBedMap[k].length > 0
        );
        const sel =
            selectedOrientation != null && selectedOrientation !== ''
                ? String(selectedOrientation)
                : '';
        // NHSelect 的 save 过滤只渲染 filterkeys 内的项；当前选中朝向若不在「有床位」列表里，
        // 不会生成 Option，Select 只有 value 没有对应文案。必须把选中项一并纳入 filterkeys。
        if (keys.length === 0 && !sel) {
            return { type: 'save', filterkeys: ['__NH_NO_ORIENTATION_WITH_BEDS__'] };
        }
        const filterkeySet = new Set(keys.map(k => String(k)));
        if (sel) {
            filterkeySet.add(sel);
        }
        return { type: 'save', filterkeys: Array.from(filterkeySet) };
    };

    //  获取宿舍示意图
    getSssyt = (csbz) => {
        this.getCssz(csbz, (data) => {
            this.normalizeImgSrc(data, (value) => {
                this.setState({
                    sssyt: value,
                    diagramImgLoadError: false
                })
            })
        })
    }

    //  获取宿舍全景图
    getSssjt = (csbz) => {
        this.getCssz(csbz, (data) => {
            this.normalizeImgSrc(data, (value) => {
                this.setState({
                    sssjt: value,
                    sceneImgLoadError: false
                })
            })
        })
    }

    //  获取参数设置
    getCssz = (csbz, callback) => {
        NHFetch(`/zzbdCommon/getCssz?csbz=${csbz}`, 'GET').then(res => {
            if (res && res.data) {
                callback(res.data);
            } else {
                message.error(`获取参数${csbz}失败`);
            }
        })
    }

    //  获取图片
    normalizeImgSrc = (fjid, callback) => {
        if (fjid) {
            NHFetch('front/zhxg-unauth/dynamic/' + fjid + '/getDetailed', 'GET').then(res => {
                if (res && res.data) {
                    let src = '';
                    if (res.data.length > 0) {
                        let uuid = res.data[0].uuid;
                        src = `zuul/docrepo/download/file?attachmentId=${uuid}`
                    } else {
                        src = `zuul/docrepo/download?attachmentId=${fjid}`
                    }
                    callback(src);
                }
            })
        }
    };

    getQueryString = name => {
        return (
            decodeURIComponent(
                (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(
                    /\+/g,
                    '%20'
                )
            ) || null
        );
    };

    queryQztjAndYlhj = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            return;
        }
        const zzbdhjid = this.getQueryString('pkid');
        this.setState({ loading: true });
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid, zzbdhjid })
            .then(res => {
                this.setState({ loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    checkIsZzbdHjLinked = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getQueryString('pkid');
        if (!xsid) {
            this.setState({ linkHandled: false }, () => {
                this.queryCwhOptionsByStu();
            });
            return;
        }
        NHFetch('/zzbdCommon/checkIsZzbdHjLinked', 'GET', { xsid, zzbdhjid })
            .then(res => {
                // 兼容返回布尔值或 { data: boolean } 两种结构
                const linked = typeof res === 'boolean' ? res : !!(res && res.data);
                this.setState(
                    linked
                        ? { linkHandled: true, cwhOptionsLoaded: true }
                        : { linkHandled: false },
                    () => {
                        if (linked) {
                            this.queryChooseDormitory();
                        } else {
                            this.queryCwhOptionsByStu();
                        }
                    }
                );
            })
            .catch(() => {
                this.setState({ linkHandled: false }, () => {
                    this.queryCwhOptionsByStu();
                });
            });
    };

    commonSaveLinkTransactionStatus = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getQueryString('pkid');
        const params = { xsid, zzbdhjid };
        NHFetch('/zzbdCommon/commonSaveLinkTransactionStatus', 'POST', params).then(res => {
            if (res) {
                if (res.data === 1) {
                    this.setState({ linkHandled: true });
                    this.reloadMenu();
                }
            } else {
                message.error('自动办理缴费环节失败，请稍后重试！');
            }
        });
    };

    setMenuList = menuList => {
        const bz = this.state.mkbz;
        let currentIndex = -1;
        menuList.forEach((elem, index) => {
            if (elem.HJDM == bz) {
                this.setState({ hjmc: elem.HJMC });
                currentIndex = index;
            }
        });

        const nextMenu = currentIndex >= 0 && currentIndex < menuList.length - 1 ? menuList[currentIndex + 1] : null;
        const nextStep = buildMenuStepUrl(nextMenu);
        if (nextMenu) {
            this.setState({
                nextUrl: nextStep.url,
                search: nextStep.search,
            });
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            });
        }
    };

    onOrientationChange = selectedOrientation => {
        this.setState({
            selectedOrientation,
            selectedBedNo: '',
        });
    };

    onBedNoChange = selectedBedNo => {
        this.setState({ selectedBedNo });
    };

    onSave = () => {
        const { selectedOrientation, selectedBedNo } = this.state;
        NHFetch('/tjstsxy/saveChooseDormitory', 'POST', {
            cwh: selectedBedNo,
            sscx: selectedOrientation,
        }).then(res => {
            if (res && res.code === 200 && res.data === 1) {
                this.commonSaveLinkTransactionStatus();
                message.success('保存成功');
            } else if (res && res.code === 200 && res.data === -1) {
                message.error('此朝向已无剩余床位号，请刷新页面重试！');
            } else {
                message.error('保存失败');
            }
        });
    };

    onImageLoadError = (type) => {
        if (type === 'scene') {
            this.setState({ sceneImgLoadError: true });
            return;
        }
        this.setState({ diagramImgLoadError: true });
    };

    render() {
        const { form } = this.props;
        const {
            loading,
            nextUrl,
            search,
            linkHandled,
            hjmc,
            selectedOrientation,
            selectedBedNo,
            sssjt,
            sssyt,
            sceneImgLoadError,
            diagramImgLoadError,
            orientationBedMap,
            cwhOptionsLoaded,
        } = this.state;
        const mapBedOptions = (orientationBedMap && orientationBedMap[selectedOrientation]) || [];
        // 已办理不调床位接口时无映射，用回填值生成一项以便只读展示
        const bedOptions =
            linkHandled && selectedBedNo && mapBedOptions.length === 0
                ? [selectedBedNo]
                : mapBedOptions;
        const sceneImgSrc = sssjt;
        const diagramImgSrc = sssyt;
        return (
            <div className="page_pay">
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref="siderMenu"
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        mkbz={this.state.mkbz}
                        menuType="自助报到"
                    />
                    <Flex.Item className="page_con_r">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: hjmc },
                            ]}
                        />
                        <div className="box">
                            <Hint />
                            <TitleTop title={hjmc || '选择宿舍'} extra={false} />
                            <Spin spinning={loading}>
                                <div className="chooseDormitory-wrap p-sw mt-20">
                                    <div className="chooseDormitory-imgGrid">
                                        <div className="chooseDormitory-imgCard">
                                            <div className="chooseDormitory-sectionTitle">宿舍实景图</div>
                                            <div className="chooseDormitory-imgBody">
                                                {sceneImgSrc && !sceneImgLoadError ? (
                                                    <img
                                                        className="chooseDormitory-img"
                                                        src={sceneImgSrc}
                                                        alt="宿舍实景图"
                                                        onError={() => this.onImageLoadError('scene')}
                                                    />
                                                ) : (
                                                    <div className="chooseDormitory-placeholder">图片未上传</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="chooseDormitory-imgCard">
                                            <div className="chooseDormitory-sectionTitle">宿舍示意图</div>
                                            <div className="chooseDormitory-imgBody">
                                                {diagramImgSrc && !diagramImgLoadError ? (
                                                    <img
                                                        className="chooseDormitory-img"
                                                        src={diagramImgSrc}
                                                        alt="宿舍示意图"
                                                        onError={() => this.onImageLoadError('diagram')}
                                                    />
                                                ) : (
                                                    <div className="chooseDormitory-placeholder">图片未上传</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="chooseDormitory-imgCard">
                                            <div className="chooseDormitory-sectionTitle">床位选择</div>
                                            <Form>
                                                <NHFormItem id={'fjcx'} label={'朝向'} form={form} required={true}>
                                                    <NHSelect
                                                        sign={"DMK_GYFW_SSCX"}
                                                        placeholder={cwhOptionsLoaded ? '请选择朝向' : '加载中...'}
                                                        value={selectedOrientation || undefined}
                                                        onChange={this.onOrientationChange}
                                                        disabled={linkHandled || !cwhOptionsLoaded}
                                                        filterData={!linkHandled ? this.getOrientationFilterData() : undefined}
                                                    />
                                                </NHFormItem>
                                                <NHFormItem id={'cwh'} label={'床位号'} form={form} required={true}>
                                                    {!linkHandled ?
                                                        <Select
                                                            className="chooseDormitory-select"
                                                            placeholder={selectedOrientation ? '请选择床位号' : '请先选择房间朝向'}
                                                            value={selectedBedNo || undefined}
                                                            onChange={this.onBedNoChange}
                                                            disabled={!selectedOrientation || linkHandled}
                                                        >
                                                            {bedOptions.map(item => {
                                                                const v = String(item);
                                                                const label = /^\d+$/.test(v) ? `${v}号床` : v;
                                                                return (
                                                                    <Option value={v} key={v}>{label}</Option>
                                                                );
                                                            })}
                                                        </Select>
                                                        : 
                                                        <Input value={selectedBedNo} disabled={true} />}
                                                </NHFormItem>
                                            </Form>
                                        </div>
                                    </div>
                                    <div className="chooseDormitory-action">
                                        {linkHandled ? (
                                            <NextButton nextUrl={nextUrl} search={search} />
                                        ) : (
                                            <Button type="primary" onClick={this.onSave}>
                                                保存
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </Spin>
                        </div>
                    </Flex.Item>
                </Flex>
            </div>
        );
    }
}
